export const svgBase64 = (svgData: string) =>
  `data:image/svg+xml;charset=UTF-8;base64,${window.btoa(svgData)}`;
